<button type="button" class="vwui-btn" (click)="openConceptReport()" [disabled]="generatingExport">
    <app-icon *ngIf="!generatingExport" iconName="pdf"></app-icon>
    <app-spinner [hidden]="!generatingExport"></app-spinner>
</button>
